export default "__VITE_ASSET__BuhQ2Nj0__"